const INTERNAL_DOMAIN = 'haven.com';
export const createExternalLinks = (html) => {
    return html.replace(/<a\s+([^>]*href="([^"]*)")([^>]*)>/gi, (match, p1, href, p3) => {
        if (!href.includes(INTERNAL_DOMAIN)) {
            return `<a ${p1} rel="noopener noreferrer" target="_blank"${p3}>`;
        }
        return match;
    });
};
